'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (IconSizes) {
  IconSizes["SM"] = "sm";
  IconSizes["MD"] = "md";
  IconSizes["LG"] = "lg";
  IconSizes["AUTO"] = "auto";
})(exports.IconSizes || (exports.IconSizes = {}));
